import HttpService from './HttpService';

class DocumentService {
  constructor() {
    this.api = HttpService;
  }

  async getDocuments() {
    const response = await this.api.get('/documents');
    return response.data;
  }

  async getDocument(id) {
    const response = await this.api.get(`/documents/${id}`);
    return response.data;
  }

  async uploadDocument(file, metadata = {}) {
    const formData = new FormData();
    formData.append('file', file);

    if (metadata.name) formData.append('name', metadata.name);
    if (metadata.description) formData.append('description', metadata.description);
    if (metadata.document_type) formData.append('document_type', metadata.document_type);
    if (metadata.house_id) formData.append('house_id', metadata.house_id);

    const response = await this.api.post('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }

  async updateDocument(id, data) {
    const response = await this.api.put(`/documents/${id}`, data);
    return response.data;
  }

  async deleteDocument(id) {
    const response = await this.api.delete(`/documents/${id}`);
    return response.data;
  }

  async getDownloadUrl(id) {
    const response = await this.api.get(`/documents/${id}/download`);
    return response.data;
  }

  async getDocumentTypes() {
    const response = await this.api.get('/documents/types');
    return response.data;
  }

  // Helper to format file size for display
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}

export default new DocumentService();
